import script from "./SignaturePadField.vue?vue&type=script&lang=ts&setup=true"
export * from "./SignaturePadField.vue?vue&type=script&lang=ts&setup=true"

import "./SignaturePadField.vue?vue&type=style&index=0&id=a132fde4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a132fde4"]])

export default __exports__